import { store } from '@/store/index.js'
import { msalInstance, loginRequest } from '@/adAuth-config'
import { InteractionRequiredAuthError } from '@azure/msal-browser'

let inFlightAuthentication = null

// Apply both silent-token and redirect results to Vuex from the same place.
export function applyAzureAuthResult(response) {
  if (!response?.account || !response.accessToken) {
    return false
  }

  msalInstance.setActiveAccount(response.account)

  const roles = Array.isArray(response.idTokenClaims?.roles)
    ? response.idTokenClaims.roles
    : []

  localStorage.setItem('yourAdRoles', JSON.stringify(roles))
  store.commit('setUsername', response.account.username)
  store.commit('setBearerToken', response.accessToken)

  const hasRole = (role) => roles.includes(role)
  store.commit('setIsFreudUser', hasRole('Freud_standard'))
  store.commit('setIsOptOutProductUser', hasRole('Gen-OptOutProducts'))
  store.commit('setIsRnDAdvancedAnalysisPlatform', hasRole('RnDAdvancedAnalysisPlatform'))
  store.commit('setIsODP_limited', hasRole('ODP_limited'))
  store.commit('setIsODP_unlimited', hasRole('ODP_unlimited'))
  store.commit('setIsRnDemployee', hasRole('RnDemployee'))
  store.commit('setIsRnDconsultant', hasRole('RnDconsultant'))
  store.commit('setIsYQI_Users', hasRole('YQI_Users'))
  store.commit('setIsGUIUsersTst', hasRole('GUIUsersTst'))
  store.commit('setIsAP3610001CLAPUsers', hasRole('AP3610001-CLAPUsers'))
  store.commit('setIsAP3610001CLAPAdmins', hasRole('AP3610001-CLAPAdmins'))
  store.commit(
    'setUserCanExportData',
    hasRole('Product_Analytics_Download') || hasRole('RnDAdvancedAnalysisPlatform')
  )

  return true
}

async function authenticateWithAzureAD() {
  let account = msalInstance.getActiveAccount()

  if (!account) {
    const accounts = msalInstance.getAllAccounts()
    if (accounts.length === 1) {
      account = accounts[0]
      msalInstance.setActiveAccount(account)
    } else {
        
      await msalInstance.loginRedirect({
        ...loginRequest,
        ...(accounts.length > 1 ? { prompt: 'select_account' } : {})
      })
      return { status: 'login_required' }
    }
  }

  const request = { ...loginRequest, account }
  let response

  try {
    response = await msalInstance.acquireTokenSilent(request)
  } catch (error) {
    if (!(error instanceof InteractionRequiredAuthError)) {
      throw error
    }

    await msalInstance.acquireTokenRedirect(request)
    return { status: 'interaction_required' }
  }

  applyAzureAuthResult(response)

  return { status: 'authenticated' }
}

export function azureADAuthentication() {
  if (!inFlightAuthentication) {
    inFlightAuthentication = authenticateWithAzureAD().finally(() => {
      inFlightAuthentication = null
    })
  }
  return inFlightAuthentication
}
